var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "14px",
    height: "17.833px",
    viewBox: "0 14.415 14 17.833",
    enableBackground: "new 0 14.415 14 17.833",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D0DCE8",
    d: "M2.985,31.478h10.203c0.469,0,0.813-0.344,0.813-0.813c0-0.422-0.28-0.688-0.616-0.858 c-0.938-0.461-1.117-1.836-0.125-2.734c0.469-0.398,0.733-0.789,0.733-1.586v-8.398c0-1.734-0.922-2.672-2.647-2.672H3 c-1.727,0-2.648,0.93-2.648,2.672v11.75C0.352,30.548,1.273,31.478,2.985,31.478z M11.156,16.204c0.703,0,1.047,0.367,1.047,1.039 v7.953c0,0.344-0.194,0.539-0.547,0.539h-7.43v-9.531H11.156z M2.141,25.97v-8.727c0-0.633,0.297-0.992,0.914-1.031v9.523 C2.703,25.759,2.407,25.837,2.141,25.97z M5.633,19.649h5.156c0.32,0,0.586-0.266,0.586-0.586c0-0.32-0.266-0.586-0.586-0.586H5.633 c-0.328,0-0.594,0.266-0.594,0.586C5.039,19.383,5.305,19.649,5.633,19.649z M5.633,21.853h3.906c0.32,0,0.586-0.267,0.586-0.594 c0-0.32-0.266-0.586-0.586-0.586H5.633c-0.328,0-0.594,0.266-0.594,0.586C5.039,21.587,5.305,21.853,5.633,21.853z M3.297,29.853 c-0.867,0-1.313-0.517-1.313-1.258c0-0.703,0.5-1.234,1.359-1.234h7.633c0.078,0,0.156-0.008,0.228-0.023 c-0.398,0.844-0.367,1.773,0.055,2.516H3.297L3.297,29.853z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.f927971dac1bdf07913f2c336b5040ed.svg";
export { ForwardRef as ReactComponent };